
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartLegend, ChartLegendContent } from '@/components/ui/chart';
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer } from 'recharts';

const carbonData = [
  { month: 'Jan', baseline: 1200, current: 1150, target: 1080 },
  { month: 'Feb', baseline: 1200, current: 1120, target: 1060 },
  { month: 'Mar', baseline: 1200, current: 1080, target: 1040 },
  { month: 'Apr', baseline: 1200, current: 1050, target: 1020 },
  { month: 'May', baseline: 1200, current: 1010, target: 1000 },
  { month: 'Jun', baseline: 1200, current: 980, target: 980 }
];

const chartConfig = {
  baseline: {
    label: 'Baseline',
    color: '#ef4444'
  },
  current: {
    label: 'Current',
    color: '#3b82f6'
  },
  target: {
    label: 'Target',
    color: '#22c55e'
  }
};

export const CarbonFootprintChart = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Carbon Footprint Reduction</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={carbonData}>
              <XAxis dataKey="month" />
              <YAxis />
              <ChartTooltip content={<ChartTooltipContent />} />
              <ChartLegend content={<ChartLegendContent />} />
              <Line 
                type="monotone" 
                dataKey="baseline" 
                stroke="var(--color-baseline)" 
                strokeWidth={2}
                strokeDasharray="5 5"
              />
              <Line 
                type="monotone" 
                dataKey="current" 
                stroke="var(--color-current)" 
                strokeWidth={2}
              />
              <Line 
                type="monotone" 
                dataKey="target" 
                stroke="var(--color-target)" 
                strokeWidth={2}
                strokeDasharray="3 3"
              />
            </LineChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
